import React from 'react';
import Modal from 'react-modal';
import { AiFillCloseCircle } from "react-icons/ai";
import button from 'assets/scss/_button.module.scss';
import style from 'assets/scss/modal.module.css';
import { Slide } from "react-awesome-reveal";

const customStyles = {
 content: {
  border: '0'
 },
 overlay: {
  backgroundColor: 'rgba(0,0,0,0.85)',
  zIndex: 1050,
 }
}

Modal.setAppElement('#root');

export default function TribesResultModal ({show, close, result, setPage, scrollToDonate}) {
    const handleClose = () => {
        close();
        setPage(0);
    }

    const handleSupportCause = () => {
        console.log(scrollToDonate);
        close();
        setTimeout(
            () => scrollToDonate.current.scrollIntoView({ behavior: 'smooth' }),
        1000
        );
    }

    return (
        <>
        <Modal 
            isOpen={show}
            style={customStyles}
            className="flex justify-center w-full h-full border-none outline-none"
        >
            <div className={`${style.__content} lg:w-[600px] lg:h-[600px] md:w-[500px] md:h-[550px] w-[90%] h-[500px] md:rounded-[0.8em] top-1/2 translate-y-[-50%] transition duration-500 bg-[#242F6F]`}>
            <div className="absolute right-3 top-3" style={{ zIndex: 9999 }}>
                <button className="text-3xl text-[#C2082A] z-1000" onClick={() => handleClose()}>
                <AiFillCloseCircle className="lg:text-5xl absolute -top-6 -right-6"/>
                </button>
            </div>
                {/* RESULT SECTION */}
                {
                result === "game-changer" &&
                    <div className="lg:p-10 md:p-8 p-5" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', zIndex: 1 }}>
                        <div className="lg:text-5xl md:text-4xl text-4xl text-left text-[#FFD600] font-mm font-bold uppercase">Game Changer</div>
                        {/* FIRST SENTENCE */}
                        <div className="lg:text-3xl md:text-2xl text-2xl text-left text-center text-[#FF8A26] font-athiti font-bold pt-2">Pillar</div>
                        <div className="lg:text-xl md:text-lg text-base text-left text-center text-[#FFE247] avenir-roman leading-2">Bruce Lee revolutionized the fight game by establishing Jeet Kune Do, a hybrid of different martial arts incorporated with his Taoist way of life.</div>
                        {/* SECOND SENTENCE */}
                        <div className="lg:text-3xl md:text-2xl text-2xl text-left text-center text-[#FF8A26] font-athiti font-bold pt-2">Mantra</div>
                        <div className="lg:text-xl md:text-lg text-base text-left text-center text-[#FFE247] avenir-roman leading-2">This tribe champions for those who want to immerse into the unusual yet beneficial.</div>
                        {/* THIRD SENTENCE */}
                        <div className="lg:text-3xl md:text-2xl text-2xl text-left text-center text-[#FF8A26] font-athiti font-bold pt-2">Your Path</div>
                        <div className="lg:text-xl md:text-lg text-base text-left text-center text-[#FFE247] avenir-roman leading-2">Begin a significant shift or a radical change for the greater good!</div>
                        <div className="text-center mt-5">
                        <button onClick={() => handleSupportCause()} className={`${button.__darkOrangeBtn} lg:m-5 m-2 avenir-roman`}>
                            <span className='lg:text-lg md:text-md text-sm avenir-roman font-normal'> Support Our Cause! </span>
                        </button>
                        </div>
                    </div>
                }

                {
                result === "creator" &&
                    <div className="lg:p-10 md:p-8 p-5" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', zIndex: 1 }}>
                        <div className="lg:text-5xl md:text-4xl text-4xl text-left text-[#FFD600] font-mm font-bold uppercase">Creator</div>
                        {/* FIRST SENTENCE */}
                        <div className="lg:text-3xl md:text-2xl text-2xl text-left text-center text-[#FF8A26] font-athiti font-bold pt-2">Pillar</div>
                        <div className="lg:text-xl md:text-lg text-base text-left text-center text-[#FFE247] avenir-roman leading-2">Bruce Lee was not content on being just an actor or martial artist, and proved it by returning to Hong Kong. He produced and directed films which broke box office records around the world.</div>
                        {/* SECOND SENTENCE */}
                        <div className="lg:text-3xl md:text-2xl text-2xl text-left text-center text-[#FF8A26] font-athiti font-bold pt-2">Mantra</div>
                        <div className="lg:text-xl md:text-lg text-base text-left text-center text-[#FFE247] avenir-roman leading-2">This tribe champions for those looking to leave an indelible mark in this world.</div>
                        {/* THIRD SENTENCE */}
                        <div className="lg:text-3xl md:text-2xl text-2xl text-left text-center text-[#FF8A26] font-athiti font-bold pt-2">Your Path</div>
                        <div className="lg:text-xl md:text-lg text-base text-left text-center text-[#FFE247] avenir-roman leading-2">Forge a legacy that people will deem unforgettable!</div>
                        <div className="text-center mt-5">
                        <button onClick={() => handleSupportCause()} className={`${button.__darkOrangeBtn} lg:m-5 m-2 avenir-roman`}>
                            <span className='lg:text-lg md:text-md text-sm avenir-roman font-normal'> Support Our Cause! </span>
                        </button>
                        </div>
                    </div>
                }

                {
                result === "explorer" &&
                    <div className="lg:p-10 md:p-8 p-5" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', zIndex: 1 }}>
                        <div className="lg:text-5xl md:text-4xl text-4xl text-left text-[#FFD600] font-mm font-bold uppercase">Explorer</div>
                        {/* FIRST SENTENCE */}
                        <div className="lg:text-3xl md:text-2xl text-2xl text-left text-center text-[#FF8A26] font-athiti font-bold pt-2">Pillar</div>
                        <div className="lg:text-xl md:text-lg text-base text-left text-center text-[#FFE247] avenir-roman leading-2">By seeking various outlets in order to formulate his fight style and personal development, Bruce Lee even added dance and nutrition to his arsenal for betterment.</div>
                        {/* SECOND SENTENCE */}
                        <div className="lg:text-3xl md:text-2xl text-2xl text-left text-center text-[#FF8A26] font-athiti font-bold pt-2">Mantra</div>
                        <div className="lg:text-xl md:text-lg text-base text-left text-center text-[#FFE247] avenir-roman leading-2">This tribe champions for those who ambitiously look for experiences.</div>
                        {/* THIRD SENTENCE */}
                        <div className="lg:text-3xl md:text-2xl text-2xl text-left text-center text-[#FF8A26] font-athiti font-bold pt-2">Your Path</div>
                        <div className="lg:text-xl md:text-lg text-base text-left text-center text-[#FFE247] avenir-roman leading-2">Your next adventure is just one step away, go and take the leap!</div>
                        <div className="text-center mt-5">
                        <button onClick={() => handleSupportCause()} className={`${button.__darkOrangeBtn} lg:m-5 m-2 avenir-roman`}>
                            <span className='lg:text-lg md:text-md text-sm avenir-roman font-normal'> Support Our Cause! </span>
                        </button>
                        </div>
                    </div>
                }

                {
                result === "caregiver" &&
                    <div className="lg:p-10 md:p-8 p-5" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', zIndex: 1 }}>
                        <div className="lg:text-5xl md:text-4xl text-4xl text-left text-[#FFD600] font-mm font-bold uppercase">Caregiver</div>
                        {/* FIRST SENTENCE */}
                        <div className="lg:text-3xl md:text-2xl text-2xl text-left text-center text-[#FF8A26] font-athiti font-bold pt-2">Pillar</div>
                        <div className="lg:text-xl md:text-lg text-base text-left text-center text-[#FFE247] avenir-roman leading-2">As a father and husband, Bruce Lee showed his humanity by being a family man. He cared for his loved ones by being heavily involved in their growth and development.</div>
                        {/* SECOND SENTENCE */}
                        <div className="lg:text-3xl md:text-2xl text-2xl text-left text-center text-[#FF8A26] font-athiti font-bold pt-2">Mantra</div>
                        <div className="lg:text-xl md:text-lg text-base text-left text-center text-[#FFE247] avenir-roman leading-2">This tribe champions for those who commit their lives in giving love to others.</div>
                        {/* THIRD SENTENCE */}
                        <div className="lg:text-3xl md:text-2xl text-2xl text-left text-center text-[#FF8A26] font-athiti font-bold pt-2">Your Path</div>
                        <div className="lg:text-xl md:text-lg text-base text-left text-center text-[#FFE247] avenir-roman leading-2">Nurture others and inspire them to be better altogether!</div>
                        <div className="text-center mt-5">
                        <button onClick={() => handleSupportCause()} className={`${button.__darkOrangeBtn} lg:m-5 m-2 avenir-roman`}>
                            <span className='lg:text-lg md:text-md text-sm avenir-roman font-normal'> Support Our Cause! </span>
                        </button>
                        </div>
                    </div>
                }

                {
                result === "sage" &&
                    <div className="lg:p-10 md:p-8 p-5" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', zIndex: 1 }}>
                        <div className="lg:text-5xl md:text-4xl text-4xl text-left text-[#FFD600] font-mm font-bold uppercase">Sage</div>
                        {/* FIRST SENTENCE */}
                        <div className="lg:text-3xl md:text-2xl text-2xl text-left text-center text-[#FF8A26] font-athiti font-bold pt-2">Pillar</div>
                        <div className="lg:text-xl md:text-lg text-base text-left text-center text-[#FFE247] avenir-roman leading-2">A significant back injury led Bruce Lee to convalescence, as he developed his personal philosophy that inspired both his combat and lifestyle.</div>
                        {/* SECOND SENTENCE */}
                        <div className="lg:text-3xl md:text-2xl text-2xl text-left text-center text-[#FF8A26] font-athiti font-bold pt-2">Mantra</div>
                        <div className="lg:text-xl md:text-lg text-base text-left text-center text-[#FFE247] avenir-roman leading-2">This tribe champions for those finding themselves through spiritual discovery.</div>
                        {/* THIRD SENTENCE */}
                        <div className="lg:text-3xl md:text-2xl text-2xl text-left text-center text-[#FF8A26] font-athiti font-bold pt-2">Your Path</div>
                        <div className="lg:text-xl md:text-lg text-base text-left text-center text-[#FFE247] avenir-roman leading-2">Yearn for the ideal, that affects you and others in a holistic and positive manner!</div>
                        <div className="text-center mt-5">
                        <button onClick={() => handleSupportCause()} className={`${button.__darkOrangeBtn} lg:m-5 m-2 avenir-roman`}>
                            <span className='lg:text-lg md:text-md text-sm avenir-roman font-normal'> Support Our Cause! </span>
                        </button>
                        </div>
                    </div>
                }
            </div>
        </Modal>
        </>
    );
}
